<style>
    img {
        margin: 35px 0;
    }

    #loading {
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        position: fixed;
        display: block;
        opacity: 0.7;
        background-color: #fff;
        z-index: 99;
        text-align: center;
    }

    #loading-image {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 150px;
        z-index: 100;
    }
</style>


<div id="page">
    <div *ngIf="loading" id="loading" >
        <img id="loading-image" src="../../../assets/images/loader.gif" alt="Loading..." />
    </div>
    <div class="container">
        <div class="col-sm-6 col-sm-offset-3">
            <img class="center-block" style="margin: 35px auto;" src="../../../assets//images/main-logo.png" alt="CellGate Logo">
            <div>
                <span><b style="font-size:20px;">{{ViewBag.Message}}</b></span>
            </div>


            <div class="panel panel-default">
                <div class="panel-heading">
                    <strong>Subscribe Callgroup</strong>
                </div>
                <div class="panel-body">
                   
                    <div class="form-group">
                        <div class="input-group">
                            <span class="input-group-addon">
                                <i class="glyphicon glyphicon-user"></i>
                            </span>
                            <input class="form-control input-sm input-gap" placeholder="Username" name="username" autofocus="" type="email" id="username">
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="input-group">
                            <span class="input-group-addon">
                                <i class="glyphicon glyphicon-lock"></i>
                            </span>
                            <input class="form-control input-sm input-gap" placeholder="Password" name="password" autofocus="" value="" type="password" id="password" pattern="^(?=.*\d)(?=.*[a-z]).{8,}$"
                                   cgPasswordToggle
                                   onkeypress="return (((event.charCode >= 48) && (event.charCode <= 57)) || ((event.charCode >= 65) && (event.charCode <= 90)) || ((event.charCode >= 97) && (event.charCode <= 122)) || ((event.charCode >= 33) && (event.charCode <= 44)) || ((event.charCode >= 46) && (event.charCode <= 47))  || ((event.charCode >= 58) && (event.charCode <= 64)) || (event.charCode == 91) || ((event.charCode >= 93) && (event.charCode <= 95)) || (event.charCode == 123) || (event.charCode == 125) )"
                                   />
                            <div class="form-group">
                                <span class="text-danger" id="status"></span>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="input-group">
                            <span class="input-group-addon">
                                <i class="glyphicon glyphicon-lock"></i>
                            </span>
                            <input class="form-control input-sm input-gap" placeholder="Repeat Password" name="confirmpassword" value="" type="password" id="confirmpassword" pattern="^(?=.*\d)(?=.*[a-z]).{8,}$"
                                   cgPasswordToggle
                                   onkeypress="return (((event.charCode >= 48) && (event.charCode <= 57)) || ((event.charCode >= 65) && (event.charCode <= 90)) || ((event.charCode >= 97) && (event.charCode <= 122)) || ((event.charCode >= 33) && (event.charCode <= 44)) || ((event.charCode >= 46) && (event.charCode <= 47))  || ((event.charCode >= 58) && (event.charCode <= 64)) || (event.charCode == 91) || ((event.charCode >= 93) && (event.charCode <= 95)) || (event.charCode == 123) || (event.charCode == 125) )"
                                 >
                            <div class="form-group">
                                <span class="text-danger" id="status"></span>
                            </div>
                        </div>
                    </div>
                    <div><label id="error" style="color: #a94442;padding-top: 7px;margin-bottom: 0;text-align: right;" class="control-label" hidden="hidden">Invalid Password</label></div>
                    <div><label id="confirmpassworderror" style="color: #a94442;padding-top: 7px;margin-bottom: 0;text-align: right;" class="control-label" hidden="hidden">Invalid Confirm Password</label></div>
                    <div><label class="control-label" style="font-size:11px;color:black;">Password should have minimum 8 and maximum 15 characters with 1 digit.</label></div>
                    <div><label class="control-label" style="font-size:11px;color:black;">Password must have at least 1 lowercase letter.</label></div>
                    <div class="form-group">
                        <span class="text-danger" id="status"></span>
                    </div>

                    <div class="align-left" *ngIf="ViewBag.Message != 'Registered Successfully.'">                           
                        <Input type="submit" class="btn btn-primary" id="btnSubmit" (click)="Subscribe()" value="Subscribe"  />                                             
                    </div>
                  
                </div>
            </div>

        </div>
    </div>
    <div class="container">
        <div class="col-sm-6 col-sm-offset-3">
            <div>
                <B style="font-size:13px" >User Name Should be</B>
                <br />
                <ul>
                    <li style="font-size:11px" >Mail format.</li>
                    <li style="font-size:11px" >Alphabet letters (A to Z and a to z), Digits (0 to 9),Hyphen(-) and Special characters (i.e. !#$%&'*+-/=?^_` {{ '{' }} | {{'}'}} ~ ).</li>
                </ul>
            </div>
            <div>
                <br />
                <B style="font-size:13px" >Password Should be</B>
                <br />
                <ul>
                    <li style="font-size:11px" >Minimum eight characters, at least one letter and one number</li>
                </ul>
            </div>
        </div>
    </div>
</div>

